import { EFFECT_TAG }  from '../../enums/index';
import LongTask  from '../LongTaskScheduler';


/**
*  基础节点的链表
*  firstNode: Node;
*  lastNode: Node;
*  count: Number;
*  render: () => void;
*/
class BaseNodeQueue {
  constructor(props) {
    this.init(props);
  }

  async init(props = {}) {
    this.firstNode = props.firstNode || null;
    this.lastNode = props.lastNode || null;
    this.count = props.count || 0;
    this.render = props.render || null;
  }

  /**
   * 推入新数据
   * @param {*} node 
   */
  push(node) {
    if (!this.firstNode) {
      this.firstNode = this.lastNode = node;
    } else {
      node.pre = this.lastNode;

      this.lastNode.next = node;
      this.lastNode = node;
    }

    this.count++;    
  }

  // 链接两个链表 但不更新lastNode 用于临时一次遍历所有queue用 注意使用break打断链表
  concat(queue) {
    if (this.lastNode && queue.firstNode) {
      this.lastNode.next = queue.firstNode;

      queue.firstNode.pre = this.lastNode;
    }
  }

  // 打断无关联的链表 用于零时concat的两个无关联链表
  break() {
    if (!this.lastNode) return;

    const otherQueueFirst = this.lastNode.next;

    if (otherQueueFirst) {
      otherQueueFirst.pre = null;
      this.lastNode.next = null;
    }
  }

  // 判断是否只有一个node
  isOnlyOneNode() {
    return this.firstNode === this.lastNode;
  }

  // 清除所有数据并销毁 Konva 节点，避免链表节点残留
  clear() {
    let node = this.firstNode;

    while (node) {
      const next = node.next;

      if (node.stateNode) {
        node.stateNode.off && node.stateNode.off();
        node.stateNode.destroy && node.stateNode.destroy();
        node.stateNode = null;
      }

      if (node.effects) {
        node.effects.clear();
      }

      node.parent = null;
      node.pre = null;
      node.next = null;
      node = next;
    }

    this.firstNode = this.lastNode = null;
    this.count = 0;
    this.render = null;
  }

  /**
   * 删除链上的某一个节点
   * @param {*} node 
   */
  deleteCurNode(node) {
    const pre = node.pre;
    const next = node.next;

    // 首个节点
    if (node === this.firstNode) this.firstNode = next || null;

    // 末个节点
    if (node === this.lastNode) this.lastNode = pre || null;

    if (pre) pre.next = next || null;

    if (next) next.pre = pre || null;
    
    this.count--;
  }

  /**
   * 删除某个节点后所有的节点
   * @param {*} firstDeleteNode 
   */
  deleteNextNode(firstDeleteNode) {
    // 首个的话直接删除所有
    if (firstDeleteNode === this.firstNode) {
      this.clear();
    } else {
      const pre = firstDeleteNode.pre;

      pre.next = null;
      this.lastNode = pre;

      // 重新统计数量
      let curNode = this.firstNode;
      let count = 0;

      while (curNode) {
        count++;
        curNode = curNode.next;
      }

      this.count = count;
    }
  }

  // 处理所有副作用的node对象
  flushEffectNode(isRender, firstNode = null) {  
    // console.time('flushEffectNode时间');
    const isNeedRender = typeof isRender === 'boolean' ? isRender : true;

    let curNode = firstNode || this.firstNode;

    while (curNode) {
      const nextNode = curNode.next;

      // 第一次对副作用节点进行stateNode上的【 图形操作 】 比如 移动 删除
      if (
        curNode.flags !== void 0 &&
        curNode.flags !== EFFECT_TAG.NO_EFFECT
      ) {
        curNode.flushEffects(true);
      }

      // 第二次对副作用节点进行【 nodeQueue链表操作 】比如删除
      if (
        (curNode.flags & EFFECT_TAG.DELETE) === EFFECT_TAG.DELETE
      ) {
        // 删除节点不需要清理flags了
        this.deleteCurNode(curNode);
      } else {
        // 不是删除的节点 清空所有副作用
        curNode.flags = EFFECT_TAG.NO_EFFECT;
      }

      curNode = nextNode;
    }
    // console.timeEnd('flushEffectNode时间');

    // 进行图层渲染
    isNeedRender && this.render && this.render();

    // 拥有长任务时执行长任务列表且不在工作中
    if (LongTask.hasTask && !LongTask.isFlushLongTask) LongTask.flushLongTask();
  }
}

export default BaseNodeQueue;